import WhatsappTemplateFormScreen from "../../../../screens/WhatsappTemplate/WhatsappTemplateForm/WhatsappTemplateFormScreen";

export const Whatsapp4uMarCom = () => {
  return <WhatsappTemplateFormScreen software="MarCom" />;
};
